import { io } from 'socket.io-client';

let socket;
let connecting;

const isTransientTransportError = (error) => (
  error?.type === 'TransportError'
  || ['xhr poll error', 'websocket error', 'timeout'].includes(error?.message)
);

export async function ensureSocket(getToken) {
  if (socket?.connected) return socket;
  if (connecting) return connecting; // prevent double connects

  connecting = (async () => {
    const token = await getToken();
    socket?.disconnect();
    socket = io(process.env.REACT_APP_API_URL, {
      transports: ['polling', 'websocket'],
      auth: { token },
      reconnection: true,
    });
    return new Promise((resolve, reject) => {
      let authRefreshAttempted = false;
      const cleanup = () => {
        socket.off('connect', onConnect);
        socket.off('connect_error', onErr);
      };
      const onConnect = () => {
        cleanup();
        resolve(socket);
      };
      const onErr = async (err) => {
        if (isTransientTransportError(err)) return;
        if (err?.message === 'Invalid token' && !authRefreshAttempted) {
          authRefreshAttempted = true;
          try {
            const refreshedToken = await getToken({ skipCache: true });
            socket.auth = { token: refreshedToken };
            socket.connect();
            return;
          } catch (refreshError) {
            cleanup();
            reject(refreshError);
            return;
          }
        }
        cleanup();
        reject(err);
      };
      socket.once('connect', onConnect);
      socket.on('connect_error', onErr);
    });
  })();

  try {
    await connecting;
  } finally {
    connecting = null;
  }
  return socket;
}

export function getSocket() {
  return socket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = undefined;
  connecting = undefined;
}
